import { ISchemaValidationErrorResponse } from '../interfaces/sessionVerification/ISchemaValidationErrorResponse';

export class SchemaValidationError extends Error {
  constructor(errorData: ISchemaValidationErrorResponse) {
    super('There were errors while validating updated objects');
    this.errorData = errorData;
  }

  public errorData: ISchemaValidationErrorResponse;
}
